var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 27,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 27,
    rx: 7.5,
    stroke: "#73007D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6307 14.3316C30.0747 17.1258 27.1238 18.8616 23.9312 18.8616C20.7365 18.8616 17.7856 17.1258 16.2296 14.3316C16.1097 14.1146 16.1097 13.8852 16.2296 13.6684C17.7856 10.8742 20.7365 9.1386 23.9312 9.1386C27.1238 9.1386 30.0747 10.8742 31.6307 13.6684C31.7527 13.8852 31.7527 14.1146 31.6307 14.3316ZM32.6247 13.1144C30.8682 9.95959 27.5371 8 23.9312 8C20.3232 8 16.9921 9.95959 15.2356 13.1144C14.9215 13.6773 14.9215 14.3227 15.2356 14.8852C16.9921 18.04 20.3232 20 23.9312 20C27.5371 20 30.8682 18.04 32.6247 14.8852C32.9388 14.3227 32.9388 13.6773 32.6247 13.1144ZM23.9312 16.3356C25.2186 16.3356 26.2663 15.2879 26.2663 13.9999C26.2663 12.7119 25.2186 11.6642 23.9312 11.6642C22.6417 11.6642 21.594 12.7119 21.594 13.9999C21.594 15.2879 22.6417 16.3356 23.9312 16.3356ZM23.9312 10.5256C22.0135 10.5256 20.4554 12.0843 20.4554 13.9999C20.4554 15.916 22.0135 17.474 23.9312 17.474C25.8468 17.474 27.4049 15.9159 27.4049 13.9999C27.4049 12.0843 25.8468 10.5256 23.9312 10.5256Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEye);
export default __webpack_public_path__ + "static/media/ic_eye.3eacd67f5e6e38673c9481be4cd75780.svg";
export { ForwardRef as ReactComponent };